import { render, staticRenderFns } from "./TextEditorFree.vue?vue&type=template&id=5eb0fa06&scoped=true"
import script from "./TextEditorFree.vue?vue&type=script&lang=js"
export * from "./TextEditorFree.vue?vue&type=script&lang=js"
import style0 from "./TextEditorFree.vue?vue&type=style&index=0&id=5eb0fa06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb0fa06",
  null
  
)

export default component.exports